import { useLanguage } from "@/components/providers/language-provider";
import { tHome } from "@/utils/i18n.home";
import { usePackagePrices } from "@/hooks/usePackagePrices";

/** Current language, home copy and live package prices. */
export function useHome() {
  const { language } = useLanguage();
  const { display } = usePackagePrices();
  const tr = (k: string) => tHome(k, language);
  return { language, tr, display };
}
